import { render, staticRenderFns } from "./AddEditAttributeMapping.vue?vue&type=template&id=c7c2ff54&"
import script from "./AddEditAttributeMapping.vue?vue&type=script&lang=js&"
export * from "./AddEditAttributeMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports